// import apiClient from "../utils/apiClient";

// // GET organizations with filters + pagination
// export const getOrganizationsApi = async (filters, page, pageSize) => {
//   const params = {
//     search: filters.search || "",
//     is_active: filters.status ? filters.status === "active" : undefined,
//     page,
//     page_size: pageSize,
//   };
//   const response = await apiClient.get("orgs/organization/", { params });
//   return response.data;
// };

// // addOrganizationApi (organizationApi.js)
// export const addOrganizationApi = async (orgData) => {
//   const formData = new FormData();
//   Object.entries(orgData).forEach(([key, value]) => {
//     if (value !== undefined && value !== null) {
//       formData.append(key, value);
//     }
//   });

//   console.log("Sending multipart FormData:", [...formData.entries()]);
//   const response = await apiClient.post("orgs/organization/", formData, {
//     headers: { "Content-Type": "multipart/form-data" },
//   });
//   return response.data;
// };

// // updateOrganizationApi
// export const updateOrganizationApi = async (orgId, orgData) => {
//   const formData = new FormData();
//   Object.entries(orgData).forEach(([key, value]) => {
//     if (value !== undefined && value !== null) {
//       formData.append(key, value);
//     }
//   });

//   console.log(`Sending multipart FormData to PUT /orgs/organization/${orgId}/:`, [...formData.entries()]);
//   const response = await apiClient.put(`orgs/organization/${orgId}/`, formData, {
//     headers: { "Content-Type": "multipart/form-data" },
//   });
//   return response.data;
// };


// // DELETE organization
// export const deleteOrganizationApi = async (orgId) => {
//   await apiClient.delete(`orgs/organization/${orgId}/`);
// };
import apiClient from "../utils/apiClient";

// helper to normalize errors
const handleApiError = (error, defaultMessage) => {
  console.error(defaultMessage, error);

  throw {
    status: error.response?.status,
    message:
      error.response?.data?.message ||
      error.response?.data?.detail ||
      defaultMessage,
    data: error.response?.data || null,
  };
};


// GET organizations with filters + pagination
export const getOrganizationsApi = async (filters, page, pageSize) => {
  try {
    const params = {
      search: filters.search || "",
      is_active: filters.status ? filters.status === "active" : undefined,
      page,
      page_size: pageSize,
    };

    const response = await apiClient.get("orgs/organization/", { params });
    return response.data;

  } catch (error) {
    handleApiError(error, "Failed to fetch organizations.");
  }
};



// ADD organization
export const addOrganizationApi = async (orgData) => {
  try {
    const formData = new FormData();

    Object.entries(orgData).forEach(([key, value]) => {
      if (value !== undefined && value !== null) {
        formData.append(key, value);
      }
    });

    console.log("Sending multipart FormData:", [...formData.entries()]);

    const response = await apiClient.post("orgs/organization/", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return response.data;

  } catch (error) {
    handleApiError(error, "Failed to create organization.");
  }
};



// UPDATE organization
export const updateOrganizationApi = async (orgId, orgData) => {
  try {
    const formData = new FormData();

    Object.entries(orgData).forEach(([key, value]) => {
      if (value !== undefined && value !== null) {
        formData.append(key, value);
      }
    });

    console.log(
      `Sending multipart FormData to PUT /orgs/organization/${orgId}/:`,
      [...formData.entries()]
    );

    const response = await apiClient.put(
      `orgs/organization/${orgId}/`,
      formData,
      {
        headers: { "Content-Type": "multipart/form-data" },
      }
    );

    return response.data;

  } catch (error) {
    handleApiError(error, "Failed to update organization.");
  }
};



// DELETE organization
export const deleteOrganizationApi = async (orgId) => {
  try {
    await apiClient.delete(`orgs/organization/${orgId}/`);
    return true;

  } catch (error) {
    handleApiError(error, "Failed to delete organization.");
  }
};
